export default function() {
  const widgetName = 'contact';
  const widgetOpts = contactOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: ''
    },
    cardWidgetLoaded: function(data, owl, hasData) {
      $('<span class="contact-title">CONTACT</span>').prependTo('#contact');
    },
    itemsPerPanel: 3,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 3,
    moreButton: {
      visible: false,
      text: ''
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: true,
    slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: true,
      margin: 10,
      navText: ['Prev','Next'],
      nav: true
    },
    textOverImage: false
  });

}